import React from "react";
import styled from "styled-components";
import Button from "../../components/Button";
import { Colors } from "../../config";
import { useNavigate } from "react-router-dom";

const dashboardBg = require("../../assets/images/bg_full.png");
const mobileBg = require("../../assets/images/bg_mobile.png");
const PageNotFoundImg = require("../../assets/images/404PageNotFound.png");
const showFlightsImg = require("../../assets/images/showFlights.png");

const NotFound = () => {
  const navigate = useNavigate();
  const isLoggedInToken = localStorage.getItem("token");

  const handleRouting = () => {
    isLoggedInToken ? navigate("/user/dashboard") : navigate("/auth/login");
  };

  return (
    <NotFoundContainer>
      <NotFoundInner>
        <Img404 src={PageNotFoundImg} alt="page-not-found" />
        <NotFoundHeader>Oops! Page not found</NotFoundHeader>
        <SubWrapper>
          <NotFoundSub>
            We're sorry, the page you requested could not be found. Please go
            back to the homepage!
          </NotFoundSub>
        </SubWrapper>
        <Button
          label="Back to Home Page"
          bgColor={Colors.pomegranate}
          width="22.5rem"
          topBottomPadding="1.063rem"
          onClick={handleRouting}
          rightImgSrc={showFlightsImg}
        />
      </NotFoundInner>
    </NotFoundContainer>
  );
};

const NotFoundContainer = styled.div`
  background: linear-gradient(rgba(0, 7, 12, 0.7), rgba(0, 7, 12, 0.7)),
    url(${dashboardBg}) no-repeat center;
  background-size: cover;
  background-attachment: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  @media only screen and (max-width: 768px) {
    background: linear-gradient(rgba(0, 7, 12, 0.7), rgba(0, 7, 12, 0.7)),
      url(${mobileBg});
  }
`;

const NotFoundInner = styled.div`
  disply: flex;
  flex-direction: column;
  text-align: center;
`;

const Img404 = styled.img`
  width: 80%;
  @media only screen and (max-width: 768px) {
    width: 55%;
  }
`;

const NotFoundHeader = styled.div`
  font-size: 2.625rem;
  color: ${Colors.white};
  margin-top: 1.063rem;
  font-weight: 700;

  @media only screen and (max-width: 768px) {
    font-size: 2rem;
  }
  @media only screen and (max-width: 375px) {
    font-size: 1.6rem;
  }
`;

const SubWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0.438rem 0 2.875rem;
`;
const NotFoundSub = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${Colors.white};
  width: 609px;

  @media only screen and (max-width: 768px) {
    font-size: 1.25rem;
    width: 100%;
  }
  @media only screen and (max-width: 375px) {
    font-size: 1rem;
    width: 100%;
  }
`;

export default NotFound;
